import { render, staticRenderFns } from "./EsportsMember_birthday.vue?vue&type=template&id=20be62eb&scoped=true&"
import script from "./EsportsMember_birthday.vue?vue&type=script&lang=js&"
export * from "./EsportsMember_birthday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20be62eb",
  null
  
)

export default component.exports